import { useEffect } from "react";
import { useProductData } from "@/zustand/productStore";
import { useMarketingStore } from "@/zustand/emailMarketingStore";
import { ProductPackageItemV2 } from "@/components/ProductPackages/ProductPackageItemV2";
import { useCartData } from "@/zustand/cartStore";

const ProductsList = () => {
  const { setSelectedProduct, selectedProduct, setVariants, setWarrantyState } = useCartData();
  const { freeShippingApplied } = useMarketingStore();
  const productData = useProductData();
  productData?.products.some((product) => product.display_name.includes("+"));
  //   colors
  const productsContent = window.post_template?.checkout_v6_products;
  const textSale = productsContent?.checkout_v6_products_textSale;
  const bestSellerBackground = productsContent?.checkout_v6_products_best_seller;
  const bestValueBackground = productsContent?.checkout_v6_products_best_value;
  const bestSellerTextColor = productsContent?.checkout_v6_products_best_seller_text_color;
  const bestValueTextColor = productsContent?.checkout_v6_products_best_value_text_color;
  const textBadge = productsContent?.checkout_v6_products_badgeTextColor;
  const cardButtonColor = window?.post_template?.checkout_v6_products?.checkout_v6_products_checkButtonCcColor;
  const cardBackground = productsContent.checkout_v6_products_CardBackground;
  const cardBackgroundSelected = productsContent.checkout_v6_products_selectedCardBackground;
  const cardBorder = productsContent.checkout_v6_products_borderColor;
  const cardBorderSelected = productsContent.checkout_v6_products_borderColorSelected;
  const textPrimary = productsContent.checkout_v6_products_textPrimary;
  const textSecondary = productsContent.checkout_v6_products_textSecondary;
  document.documentElement.style.setProperty("--checkbutton-cc-color", cardButtonColor);
  document.documentElement.style.setProperty("--card-background-active", cardBackgroundSelected);
  document.documentElement.style.setProperty("--card-border-active", cardBorderSelected);
  document.documentElement.style.setProperty("--card-border", cardBorder);
  document.documentElement.style.setProperty("--card-background", cardBackground);
  document.documentElement.style.setProperty("--card-text-primary", textPrimary);
  document.documentElement.style.setProperty("--card-text-secondary", textSecondary);
  document.documentElement.style.setProperty("--sale-text", textSale);
  document.documentElement.style.setProperty("--best-seller-background", bestSellerBackground);
  document.documentElement.style.setProperty("--best-value-background", bestValueBackground);
  document.documentElement.style.setProperty("--best-value-text", bestValueTextColor);
  document.documentElement.style.setProperty("--best-seller-text", bestSellerTextColor);
  document.documentElement.style.setProperty("--text-badge", textBadge);

  useEffect(() => {
    if (freeShippingApplied) {
      productData.changeProductsShippingPrice(0);
    }
  }, [freeShippingApplied, productData]);

  const handleChange = (product) => {
    setSelectedProduct({
      sku: product.sku?.trim(),
      amount: product.amount,
      konnektive_id: product.konnektive_id?.trim(),
      bundle_products: product.bundle_products,
      warranty_price: product.warranty_price,
      warranty_product_id: product.warranty_product_id,
      display_name: product.display_name,
      generic_name: product.generic_name,
      bundle_title: product.bundle_title,
      price: product.price,
      old_price: product.old_price,
      shipping_price: product.shipping_price,
      promo_discounted_price: product.promo_discounted_price,
      promo_shipping_price: product.promo_shipping_price,
      fake_products: product.fake_products,
      enable_fake_products: product.enable_fake_products,
    });
  };

  return (
    <>
      {productData?.products &&
        productData?.products.map((product, i) => {
          return (
            <ProductPackageItemV2
              key={i}
              product={product}
              handleChange={() => handleChange(product)}
              active={selectedProduct?.price === product?.price}
              index={i}
            />
          );
        })}
    </>
  );
};

export default ProductsList;
